import { Col, Form, Input, Row } from 'antd';
import React, { useEffect } from 'react';


const MultiTextBox = ({
    name,
    defaultValue,
    controlWidth,
    required,
    errorMessage,
    disabled,
    controlsNo,
    label,
    placeholder,
    form,
    maxLength
}) => {

    useEffect(() => {
        form.setFieldValue(name, defaultValue);
    }, []);

    const isRequired = (index) => {
        if (typeof (required) === 'boolean') {
            return required;
        };
        if (typeof (required) === 'object') {
            return required[index]
        }
    }

    return (
        <>
            <Row>
                <Col span={24} className='ant-form-item-label ant-form-item-label-wrap' style={{ display: 'inline-flex', justifyContent: 'space-between' }}>
                    <label className={`${required ? 'ant-form-item-required' : ''} ant-form-item-no-colon`} title={label}>{label}</label>
                </Col>
            </Row>

            <div style={{ display: 'inline-flex', justifyContent: 'flex-start', flexWrap: 'wrap' }}>
                {
                    Array.from({ length: controlsNo }).map((_, idx) => (
                        <Form.Item
                            //    label={label}
                            key={name + "input" + idx}
                            style={{ width: controlWidth[idx] }}
                            name={[name, idx]}
                            //    initialValue={defaultValue ? defaultValue[idx] : null}
                            rules={[
                                { required: isRequired(idx), message: errorMessage }
                            ]}
                        >
                            <Input
                                type='text'
                                disabled={disabled}
                                placeholder={placeholder}
                                maxLength={maxLength}
                            />
                        </Form.Item>
                    ))
                }
            </div>
        </>
    )
};

export default MultiTextBox;